


export class TourFeatures {
  about: TourFeature;
  community: TourFeature;
  contacts: TourFeature;
  feedback: TourFeature;
  wishlist: TourFeature;

  constructor(public data: any) {
    const j: JSON = data;
    this.about = new TourFeature(j['about'], 'Model Info');
    this.community = new TourFeature(j['community'], 'Community Info');
    this.contacts = new TourFeature(j['contacts'], 'Contacts');
    this.feedback = new TourFeature(j['feedback'], 'Ratings & Reviews');
    this.wishlist = new TourFeature(j['wishlist'], 'Wish List');
  }
}

export class TourFeature {
  enabled: boolean;
  downloaded: boolean;
  label: string;
  constructor(public data: any, defaultLabel: string) {
    const j: JSON = data;
    this.enabled = j['enabled'];
    if (j['label']) {
      this.label = j['label'];
    } else {
      this.label = defaultLabel;
    }
    this.downloaded = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/model/tour-features.ts